import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { City } from '@/data/cities';

export const useCityFromDatabase = (citySlug: string) => {
  return useQuery({
    queryKey: ['city-database', citySlug],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('cities')
        .select('*')
        .eq('slug', citySlug)
        .eq('is_active', true)
        .single();

      if (error) {
        if (error.code === 'PGRST116') {
          // No rows returned
          return null;
        }
        throw error;
      }

      if (!data) return null;

      // Transform database city to City type
      const city: City = {
        id: data.id,
        name: data.name,
        country: data.country,
        countryCode: data.country.substring(0, 2).toUpperCase(), // Fallback
        population: 100000, // Default population
        coordinates: {
          lat: data.latitude || 0,
          lng: data.longitude || 0
        },
        language: 'en', // Will be detected
        timezone: 'UTC', // Default timezone
        slug: data.slug,
        state_province: data.state_province || undefined
      };

      return city;
    },
    staleTime: 1000 * 60 * 10, // 10 minutes
    retry: false, // Don't retry on 404
  });
};
